import React from 'react';

import {
  Stack,
  Typography,
  IconButton,
  ClearIcon,
  EditIcon,
} from '@gogame/components';
import { DateValueFormatter } from '@gogame/intl-ts';
import { ScreenLink } from '@gogame/screens';

import {
  marketingPlanningPreviewLink,
  marketingPlanningWizardLink,
} from 'scenes/MarketingPlanning/navigation';

const Current = ({ row, onDiscard }) => {
  const handleDiscard = () => onDiscard(row);

  return (
    <Stack
      direction={'row'}
      justifyContent={'space-between'}
      alignItems={'center'}
    >
      <Stack>
        <Typography variant={'body2'}>
          <ScreenLink
            link={marketingPlanningPreviewLink}
            params={{ year: row?.year, month: row?.month }}
            style={{ textDecoration: 'underline' }}
            target={'_blank'}
          >
            {row?.hasUnsavedChanges ? 'Unsaved changes' : row?.viewVersion}
          </ScreenLink>
        </Typography>

        <Typography variant={'caption'} color={'textSecondary'}>
          <DateValueFormatter
            value={row?.dateUpdated}
            template={'LLL'}
            timeZone={'local'}
          />
          &nbsp;by&nbsp;{row?.lastUpdatedBy}
        </Typography>
      </Stack>

      <Stack direction={'row'}>
        {row?.hasUnsavedChanges ? (
          <IconButton
            icon={<ClearIcon />}
            tooltip={'Discard changes'}
            onClick={handleDiscard}
          />
        ) : null}
        <ScreenLink
          link={marketingPlanningWizardLink}
          params={{ year: row?.year, month: row?.month }}
          style={{ textDecoration: 'underline' }}
        >
          <IconButton icon={<EditIcon />} tooltip={'Edit'} />
        </ScreenLink>
      </Stack>
    </Stack>
  );
};
export default Current;
